'use strict';

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _applicationState = require('./applicationState');

var _guideIdUtils = require('./guideIdUtils');

var _guideIdUtils2 = _interopRequireDefault(_guideIdUtils);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adsSettings = void 0;

function getClassificationProperty(profileClassification) {
  var nowPlayingClassification = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : profileClassification;

  var currentProfile = adsSettings.currentProfile();
  var profileValue = (0, _get2.default)(currentProfile, 'metadata.properties.classification.' + profileClassification);
  if (!(0, _isNil2.default)(profileValue)) {
    return profileValue;
  }
  var nowPlaying = (0, _applicationState.getState)(_applicationState.State.nowPlaying);
  return (0, _get2.default)(nowPlaying, 'classification.' + nowPlayingClassification);
}

adsSettings = {
  currentProfile: function currentProfile() {
    var profiles = (0, _applicationState.getState)(_applicationState.State.profiles);
    var selectedGuideId = (0, _applicationState.getState)(_applicationState.State.selectedGuideId);

    return profiles && profiles[selectedGuideId];
  },
  canShowAds: function canShowAds() {
    var currentProfile = this.currentProfile();
    var adsEnabled = (0, _applicationState.getState)(_applicationState.State.adsEnabled);
    var adsEnabledOnThisPage = (0, _get2.default)(currentProfile, 'metadata.properties.ads.adEligible', true);
    var isPlaying = (0, _applicationState.getState)(_applicationState.State.playerStatus) === _constants2.default.PlayStates.playing;
    var nowPlaying = (0, _applicationState.getState)(_applicationState.State.nowPlaying);
    var canShowAds = (0, _get2.default)(nowPlaying, 'ads.canShowAds', true);
    return adsEnabled && !this.isPremium() && adsEnabledOnThisPage && (canShowAds || !isPlaying);
  },
  canShowCompanionAds: function canShowCompanionAds() {
    var currentProfile = this.currentProfile();
    var adsEnabledOnThisPage = (0, _get2.default)(currentProfile, 'metadata.properties.ads.adEligible', true);
    var nowPlaying = (0, _applicationState.getState)(_applicationState.State.nowPlaying);
    var canShowCompanionAds = (0, _get2.default)(nowPlaying, 'ads.canShowCompanionAds', true);
    return !this.isPremium() && adsEnabledOnThisPage && canShowCompanionAds;
  },
  canShowPrerollAds: function canShowPrerollAds() {
    var currentProfile = this.currentProfile();
    var adsEnabledOnThisPage = (0, _get2.default)(currentProfile, 'metadata.properties.ads.adEligible', true);
    var nowPlaying = (0, _applicationState.getState)(_applicationState.State.nowPlaying);
    var canShowPrerollAds = (0, _get2.default)(nowPlaying, 'ads.canShowPrerollAds', true);
    var unlockDetails = (0, _applicationState.getState)(_applicationState.State.unlockDetails);
    var disablePreroll = (0, _get2.default)(unlockDetails, 'DisablePreroll', false) && this.isUnlocked();
    return !this.isPremium() && adsEnabledOnThisPage && canShowPrerollAds && !disablePreroll;
  },
  getGuideItemDetails: function getGuideItemDetails() {
    var guideItemDetails = {};

    // use now playing details
    var nowPlaying = (0, _applicationState.getState)(_applicationState.State.nowPlaying);
    _guideIdUtils2.default.extractTypedGuideIds((0, _get2.default)(nowPlaying, 'secondaryGuideId'), guideItemDetails);
    _guideIdUtils2.default.extractTypedGuideIds((0, _get2.default)(nowPlaying, 'primaryGuideId'), guideItemDetails);

    // overwrite now playing details with profile details
    var currentProfile = this.currentProfile();
    var guideId = (0, _get2.default)(currentProfile, 'guideId');
    _guideIdUtils2.default.extractTypedGuideIds(guideId, guideItemDetails);

    return guideItemDetails;
  },
  getGenreId: function getGenreId() {
    return getClassificationProperty('primaryGenreId', 'genreId');
  },
  isFamilyContent: function isFamilyContent() {
    return getClassificationProperty('isFamilyContent');
  },
  isMatureContent: function isMatureContent() {
    return getClassificationProperty('isMatureContent');
  },
  isEvent: function isEvent() {
    return getClassificationProperty('isEvent');
  },
  isOnDemand: function isOnDemand() {
    return getClassificationProperty('isOnDemand');
  },
  isPremium: function isPremium() {
    return (0, _applicationState.getState)(_applicationState.State.subscriptionStatus) === _constants2.default.SubscriptionStatus.active;
  },
  isUnlocked: function isUnlocked() {
    var unlockDetails = (0, _applicationState.getState)(_applicationState.State.unlockDetails);
    var unlockEndDate = (0, _get2.default)(unlockDetails, 'EndDate');
    return unlockEndDate ? new Date(unlockEndDate) > Date.now() : false;
  },
  getClass: function getClass() {
    return getClassificationProperty('rootGenreClassification', 'contentType');
  },
  getNowPlayingGuideIds: function getNowPlayingGuideIds() {
    var ret = [];
    var nowPlaying = (0, _applicationState.getState)(_applicationState.State.nowPlaying);
    var primaryGuideId = _guideIdUtils2.default.sanitize((0, _get2.default)(nowPlaying, 'primaryGuideId'));
    if (primaryGuideId) {
      ret.push(primaryGuideId);
    }
    var secondaryGuideId = _guideIdUtils2.default.sanitize((0, _get2.default)(nowPlaying, 'secondaryGuideId'));
    if (secondaryGuideId) {
      ret.push(secondaryGuideId);
    }
    return ret;
  }
};

module.exports = adsSettings;